import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        assessment : {
            item:[]
        },
        isReload: false,
    },

    mutations: {
        assessment(state, obj) {
            state.assessment = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.assessment('exp', data, {})
                .then((response) => {
                    store.commit("assessment/assessment", response.data.data[0])

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.assessment('post', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
        update({commit}, data) {
            Service.assessment('put', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },

        remove({commit}, data) {
            store.commit("dialog/loading",true)
            Service.assessment('delete', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",true)

                }).catch((err) => {
            });
        },

    },

    getters: {
        assessment(state, obj) {
            return state.assessment;
        },

        isReload(state, obj) {
            return state.isReload;
        }
    },
};

export default ServerModule;
